"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isShowStencil = exports.showStencilDefinition = void 0;
const properties_1 = require("../properties");
exports.showStencilDefinition = {
    view: {
        label: 'Show',
        category: 'show',
        group: 'Moving images',
        titleItems: ['title'],
        imageItems: ['featured-media'],
        contentAreas: [
            {
                name: 'main',
                items: [
                    'header-media',
                    'title',
                    'subheading',
                    'teaser',
                    'description',
                ],
            },
            {
                name: 'info',
                subAreas: [
                    {
                        name: 'General',
                        items: [
                            'seo-title',
                            'social-title',
                            'featured-title',
                            'uri-title',
                            'url',
                            'featured-media',
                            'social-media-image',
                            'featured-video',
                            'logos',
                            'season-ref',
                        ],
                    },
                    {
                        name: 'CTA',
                        items: ['cta-container'],
                    },
                    {
                        name: 'Settings',
                        items: [
                            'search-terms',
                            'standalone',
                            'no-monetization',
                        ],
                    },
                    {
                        name: 'Custom Properties',
                        items: ['properties-container'],
                    },
                ],
            },
            {
                name: 'tagging',
                items: [
                    'disciplines',
                    'content-categories',
                    'tag-events',
                    'tag-event-series',
                    'tag-persons',
                    'tag-teams',
                    'related-content',
                ],
            },
        ],
        previewConfiguration: {
            hasPagePreview: true,
            hasFeatureCardPreview: true,
        },
    },
    content: {
        [properties_1.contentCategoriesPropertyDefinition.name]: properties_1.contentCategoriesPropertyDefinition,
        [properties_1.ctaContainerPropertyDefinition.name]: properties_1.ctaContainerPropertyDefinition,
        [properties_1.descriptionPropertyDefinition.name]: properties_1.descriptionPropertyDefinition,
        [properties_1.disciplinesPropertyDefinition.name]: {
            ...properties_1.disciplinesPropertyDefinition,
            constraints: [
                {
                    name: 'required',
                    argument: true,
                },
                {
                    name: 'stencils',
                    argument: ['discipline'],
                },
            ],
        },
        [properties_1.featuredMediaPropertyDefinition.name]: properties_1.featuredMediaPropertyDefinition,
        [properties_1.featuredTitlePropertyDefinition.name]: properties_1.featuredTitlePropertyDefinition,
        [properties_1.featuredVideoPropertyDefinition.name]: {
            ...properties_1.featuredVideoPropertyDefinition,
            view: {
                label: 'Featured video',
                hint: 'Used to represent the content piece on collection pages.',
                hintAdditional: 'If there is a preview clip available it will be automatically embedded here after publishing. Please notice it may take a few minutes upon publishing before the preview clip will show.',
            },
        },
        [properties_1.headerMediaPropertyDefinition.name]: {
            ...properties_1.headerMediaPropertyDefinition,
            constraints: [
                {
                    name: 'required',
                    argument: true,
                },
                {
                    name: 'stencils',
                    argument: [
                        'image',
                        'video',
                        'episode-video',
                        'film',
                        'recap-video',
                        'trailer-video',
                        'video-channel',
                    ],
                },
            ],
        },
        [properties_1.logosPropertyDefinition.name]: properties_1.logosPropertyDefinition,
        [properties_1.noMonetizationPropertyDefinition.name]: properties_1.noMonetizationPropertyDefinition,
        [properties_1.propertiesContainerPropertyDefinition.name]: properties_1.propertiesContainerPropertyDefinition,
        [properties_1.relatedContentPropertyDefinition.name]: properties_1.relatedContentPropertyDefinition,
        [properties_1.searchTermsPropertyDefinition.name]: properties_1.searchTermsPropertyDefinition,
        [properties_1.seasonRefPropertyDefinition.name]: properties_1.seasonRefPropertyDefinition,
        [properties_1.seoTitlePropertyDefinition.name]: properties_1.seoTitlePropertyDefinition,
        [properties_1.socialMediaImagePropertyDefinition.name]: properties_1.socialMediaImagePropertyDefinition,
        [properties_1.socialTitlePropertyDefinition.name]: properties_1.socialTitlePropertyDefinition,
        [properties_1.standalonePropertyDefinition.name]: {
            ...properties_1.standalonePropertyDefinition,
            default: true,
        },
        [properties_1.subheadingPropertyDefinition.name]: properties_1.subheadingPropertyDefinition,
        [properties_1.tagEventSeriesPropertyDefinition.name]: properties_1.tagEventSeriesPropertyDefinition,
        [properties_1.tagEventsPropertyDefinition.name]: properties_1.tagEventsPropertyDefinition,
        [properties_1.tagPersonsPropertyDefinition.name]: properties_1.tagPersonsPropertyDefinition,
        [properties_1.tagTeamsPropertyDefinition.name]: properties_1.tagTeamsPropertyDefinition,
        [properties_1.teaserPropertyDefinition.name]: properties_1.teaserPropertyDefinition,
        [properties_1.titlePropertyDefinition.name]: properties_1.titlePropertyDefinition,
        [properties_1.uriTitlePropertyDefinition.name]: properties_1.uriTitlePropertyDefinition,
        [properties_1.urlPropertyDefinition.name]: properties_1.urlPropertyDefinition,
    },
    localizations: [],
    roles: [],
    spaces: [
        'brand-building-events',
        'media-partnerships',
        'racing-bulls',
        'rbtv',
        'rbtv_temporary',
        'redbull_com',
        'redbull-racing',
    ],
    name: 'show',
};
const isShowStencil = (stencil) => {
    return stencil.name === exports.showStencilDefinition.name;
};
exports.isShowStencil = isShowStencil;
//# sourceMappingURL=data:application/json;base64,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